import { ClockIcon } from '@p2p/assets/svg';
import { TGetOrderResponse } from '@p2p/services';
import { PaymentType } from '@p2p/shared/constants';
import { addZero, formatNumber, getOrderAmount } from '@p2p/shared/functions';
import classNames from 'classnames';
import { FC, useMemo } from 'react';

import styles from '../../styles.module.scss';

const MINUTE = 60;

type TransferHeadProps = {
  id: string;
  time?: number;
  order: TGetOrderResponse;
  status: string;
};

export const TransferHead: FC<TransferHeadProps> = ({ id, time, order, status }) => {
  const formatTime = useMemo(
    () => `${addZero((time ?? 0) / 60 || 0)}:${addZero((time ?? 0) % 60)}`,
    [time],
  );

  return (
    <div className={styles.transfer_dialog__header}>
      <div className={styles.transfer_dialog__header_info}>
        <div className={styles.transfer_dialog__header_title}>
          {order?.requisite.payment_type === PaymentType.PAYMENT_TYPE_SBP && 'Оплата через СБП'}
          {order?.requisite.payment_type === PaymentType.PAYMENT_TYPE_C2C &&
            'Оплата по номеру карты'}
          {order?.requisite.payment_type === PaymentType.PAYMENT_TYPE_TRANSFER &&
            'Оплата по номеру счета'}
        </div>
        {time !== undefined && (
          <div
            className={classNames(
              { [styles.warning]: time < MINUTE * 2 },
              styles.transfer_dialog__header_time_wr,
            )}
          >
            <ClockIcon />
            {time > 0 && <div className={styles.transfer_dialog__header_time}>{formatTime}</div>}
          </div>
        )}
      </div>
      <div className={styles.transfer_dialog__header_amount}>
        {/* todo: Нужно добавить функцию для добавления пробелов между разрядами в сумме (здесь и в других местах) */}
        {formatNumber(getOrderAmount(order))}
        <span>RUB</span>
      </div>
    </div>
  );
};
